import React from "react";
import {
  buildDateText,
  getCurrencySign,
  formatAmount,
} from "../../../controller/helper.js";

export default function EventDetailsModal({ open, event, onClose }) {
  if (!open || !event) return null;

  return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-xl modal-dialog-scrollable">
        <div className="modal-content bg-dark text-white border-0">

          {/* HEADER */}
          <div className="modal-header border-secondary">
            <h4 className="modal-title text-white fw-bold">{event.etitle}</h4>
            <button
              className="btn-close btn-close-white"
              onClick={onClose}
            ></button>
          </div>

          {/* BODY */}
          <div className="modal-body">

            {/* IMAGE BANNER */}
            {event.pic_img && (
              <div className="mb-4">
                <img
                  src={`http://localhost:5000${event.pic_img}`}
                  alt=""
                  className="img-fluid rounded w-100"
                  style={{ maxHeight: "350px", objectFit: "cover" }}
                />
              </div>
            )}

            {/* TOP INFO */}
            <div className="row mb-4">
              <div className="col-md-4">
                <div className="p-3 bg-black rounded">
                  <small className="text-white-50">Status</small>
                  <div className="fw-bold">
                    {event.visibilitystatus === 0 ? "Visible" : "Hidden"}
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="p-3 bg-black rounded">
                  <small className="text-white-50">Type</small>
                  <div className="fw-bold">
                    {event.isfree ? "Free Event" : "Paid Event"}
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="p-3 bg-black rounded">
                  <small className="text-white-50">No of Registrants</small>
                  <div className="fw-bold">{event.reg_counts}</div>
                </div>
              </div>
            </div>

            <div className="row">

              {/* LEFT SIDE */}
              <div className="col-md-7">

                {/* DETAILS */}
                <div className="mb-4">
                  <h5 className="mb-3 border-bottom pb-2">Event Details</h5>

                  {event.sections?.length ? (
                    event.sections.map((sec) => (
                      <div
                        key={sec.id}
                        className="p-3 mb-3 bg-black rounded"
                      >
                        <div className="fw-bold mb-1">{sec.title}</div>
                        <div className="text-white-50 small">
                          {sec.detail}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-white-50">No details available</div>
                  )}
                </div>

                {/* SCHEDULES */}
                <div>
                  <h5 className="mb-3 border-bottom pb-2">Schedules</h5>

                  {event.schedules?.length ? (
                    event.schedules.map((s, i) => (
                      <div
                        key={i}
                        className="p-3 mb-3 bg-black rounded"
                      >
                        <div className="fw-bold">
                          {buildDateText(s.startdate, s.enddate)}
                        </div>

                        <div className="small text-white-50">
                          Time: {s.timeduration}
                        </div>

                        <div className="small text-white-50">
                          Mode: {s.deliverymode}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-white-50">No schedules</div>
                  )}
                </div>

              </div>

              {/* RIGHT SIDE */}
              <div className="col-md-5">

                {/* PRICING */}
                <div className="mb-4">
                  <h5 className="mb-3 border-bottom pb-2">Pricing</h5>

                  {event.price?.length ? (
                    event.price.map((p) => (
                      <div
                        key={p.pid}
                        className="d-flex justify-content-between p-3 mb-2 bg-black rounded"
                      >
                        <span>{p.country}</span>
                        <span className="fw-bold">
                          {getCurrencySign(p.country)}{" "}
                          {formatAmount(p.price)}
                        </span>
                      </div>
                    ))
                  ) : (
                    <div className="text-white-50">Free Event</div>
                  )}
                </div>

              </div>

            </div>
          </div>

          {/* FOOTER */}
          <div className="modal-footer border-secondary">
            <button className="btn btn-outline-light" onClick={onClose}>
              Close
            </button>
          </div>

        </div>
      </div>

      {/* BACKDROP */}
      <div
        className="modal-backdrop fade show"
        onClick={onClose}
      ></div>
    </div>
  );
}